module.exports = __webpack_public_path__ + "img/2-3.61bb2e15.png";